import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import {
    AlulaEffects,
    AlulaReceiverBindEffects,
    AlulaReceiverEffects,
    AlulaReceiverGroupEffects,
    ClareoneLogEffects,
    DeviceEffects,
    DeviceMetadataEffects,
    EmergencyContactEffects,
    ProjectEffects,
    ServiceEffects,
    ServiceMetadataEffects,
    ServicePlanEffects,
    SubscriptionEffects,
} from "./effects";
import { EventLogEffects } from "./effects/event-log.effects";
import { MunicipalityEffects } from "./effects/municipality.effects";
import { ProjectFeatureEffects } from "./effects/project-feature.effects";
import { ProjectViewEffects } from "./effects/project-view.effects";
import {
    alulaReducer,
    chDeviceMetadatareducer,
    chDevicereducer,
    chLiteServicereducer,
    chServicereducer,
    emergencyContactReducer,
    municipalityReducer,
    reducer,
    servicePlanReducer,
    subscriptionReducer,
} from "./reducers";
import { chDeviceClassObjectreducer } from "./reducers/ch-deviceclassobjects.reducers";
import { chServiceMetadatareducer } from "./reducers/ch-service-metadata.reducers";
import { eventLogReducer } from "./reducers/event-log.reducers";
import { ServicePlansDbService } from "./services/service-plan-db.service";
import { ClareSubscriptionDbService } from "./services/subscription-db.service";
import { chZWaveDeviceReducer } from "./reducers/ch-zwave-devices.reducer";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature("project", reducer),
        StoreModule.forFeature("chservice", chServicereducer),
        StoreModule.forFeature("chliteservice", chLiteServicereducer),
        StoreModule.forFeature("chdevice", chDevicereducer),
        StoreModule.forFeature("chzwavedevice", chZWaveDeviceReducer),
        StoreModule.forFeature("chdevicemetadata", chDeviceMetadatareducer),
        StoreModule.forFeature("chservicemetadata", chServiceMetadatareducer),
        StoreModule.forFeature("chdeviceclassobject", chDeviceClassObjectreducer),
        StoreModule.forFeature("servicePlan", servicePlanReducer),
        StoreModule.forFeature("alula", alulaReducer),
        StoreModule.forFeature("subscription", subscriptionReducer),
        StoreModule.forFeature("municipality", municipalityReducer),
        StoreModule.forFeature("emergency-contact", emergencyContactReducer),
        StoreModule.forFeature("event-log-reducer", eventLogReducer),
        EffectsModule.forFeature([
            ProjectEffects,
            ServiceEffects,
            AlulaEffects,
            AlulaReceiverEffects,
            AlulaReceiverGroupEffects,
            AlulaReceiverBindEffects,
            DeviceEffects,
            DeviceMetadataEffects,
            ServiceMetadataEffects,
            ServicePlanEffects,
            SubscriptionEffects,
            ProjectViewEffects,
            MunicipalityEffects,
            EmergencyContactEffects,
            EventLogEffects,
            ClareoneLogEffects,
            ProjectFeatureEffects,
        ]),
    ],
    providers: [
        ProjectEffects,
        ServiceEffects,
        AlulaEffects,
        AlulaReceiverEffects,
        AlulaReceiverGroupEffects,
        AlulaReceiverBindEffects,
        DeviceEffects,
        DeviceMetadataEffects,
        ServiceMetadataEffects,
        ServicePlanEffects,
        SubscriptionEffects,
        ProjectViewEffects,
        ServicePlansDbService,
        ClareSubscriptionDbService,
        ClareoneLogEffects,
        ProjectFeatureEffects,
    ],
})
export class ProjectsStoreModule {}
